export const ENDPOINTS = {
  APPOINTMENT: {
    GET: "appointments",
    GET_DETAIL: "appointments",
    REPLY: "appointments/reply",
    CLOSE: "appointments/close",
    CANCEL: "appointments/cancel",

    CREATE: "parent/appointments",
    GET_PARENT: "parent/appointments",
    CONFIRM: "parent/appointments/confirm",
    PARENT_CANCEL: "parent/appointments/cancel",
    RESCHEDULE: "parent/appointments/reschedule",
  },

  ASSESSMENT_LIST: {
    GET: "exams",
    GET_ASSESSMENT_LIST: "exams",
    CREATE: "exams",
    UPDATE: "exams",
    DELETE: "exams",
  },
  ASSESSMENT_MARKING: {
    GET_ASSESSMENT_PARTICIPANTS: "event/participants",
    CREATE: "event/marking",
    UPDATE: "update/event/marking",
  },
  ATTENDANCE: {
    GET: "attendance",
    CREATE: "attendance",
    UPDATE: "attendance/update",
    DELETE: "attendance",
    GET_ATTENDANCE_REPORT: "get/attendance/date-range",
    GET_MAPPED_PROGRAMS: "attendance-teacher-mappings",
    CREATE_ATTENDANCE_TEACHER_MAPPING: "attendance-teacher-mappings",
    GET_ATTENDANCE_LABEL_LIST: "attendance/label/list",
    BULK_UPLOAD: "attendance-upload",
    GET_PROGRAM_WISE_ATTENDANCE_COUNT: "program-wise/attendance-count",
    GET_ATTENDANCE_SUMMARY: "attendance/summary/details",
    GET_ATTENDANCE_PERCENTAGE_REPORT: "attendance-percentage-report",
    GET_ATTENDANCE_MARKED_TIMES: "attendance-mark-times",
    DOWNLOAD_REPORT: "attendance-report/download",
    GET_STUDENTS_BY_STATUS: "attendance/students-by-status",
  },
  CIRCULAR: {
    GET: "circular",
    CREATE: "circular",
    UPDATE: "circular/update",
    DELETE: "circular",
    GET_AVAILABLE_placeholderS: "circular/available/placeholders",
  },
  CLASS_TEACHER: {
    GET: "class-teacher",
    GET_CLASS_TEACHER: "class-teacher",
    CREATE: "class-teacher",
    UPDATE: "class-teacher",
    DELETE: "class-teacher",
  },
  DASHBOARD: {
    GET_ADMIN_SUMMARY: "dashboard/admin/summary",
    GET_TEACHER_SUMMARY: "dashboard/teacher/summary",
  },
  EVENT_CALENDAR: {
    GET: "event-calendar",
    GET_EVENT_CALENDAR: "event-calendar",
    CREATE: "event-calendar",
    UPDATE: "event-calendar",
    DELETE: "event-calendar",
  },
  EXAM: {
    GET: "events",
    GET_FILTERED: "events",
    GET_EXAM: "events",
    CREATE: "events",
    UPDATE: "events",
    DELETE: "events",
    GET_PROGRAM_WISE_SUBJECTS: "class/subjects",
    GET_PROGRAM_WISE_EXAM: "program/exams",
    STATUS_UPDATE: "event/active-in-active",
    BULK_CREATE: "bulk/event/create",
    CONFIG_BULK_CREATE: "bulk/event/config/create",
    UPDATE_END_DATE: "update/event/end-date",
    REMOVE_STUDENT_EXAMS_ENROLLMENT: "remove/student/exams/enrollment",
    ADD_STUDENT_EXAMS_ENROLLMENT: "add/student/exams/enrollment",
  },
  EXAM_CONFIG: {
    GET: "event_configs",
    GET_FILTERED: "event_configs",
    GET_EXAM_CONFIG: "event_configs",
    CREATE: "event_configs",
    UPDATE: "event_configs",
    DELETE: "event_configs",
    GET_PROGRAM_WISE_SUBJECTS: "class/subjects",
    GET_PROGRAM_WISE_EXAM: "program/exams",
    STATUS_UPDATE: "event/active-in-active",
  },
  EVALUATION_TYPE: {
    GET: "evaluation_types",
    GET_EVALUATION_TYPE: "evaluation_types",
    CREATE: "evaluation_types",
    UPDATE: "evaluation_types",
    DELETE: "evaluation_types",
  },
  FAQ: {
    GET: "faq",
    GET_FAQ: "faq",
    CREATE: "faq",
    UPDATE: "faq",
    DELETE: "faq",
  },
  HOMEWORK: {
    GET: "homework/teacher",
    GET_HOMEWORK: "homework/show",
    CREATE: "homework/create",
    UPDATE: "homework/update",
    DELETE: "homework/delete",
  },
  LEAVE: {
    GET: "leave",
    GET_LEAVE: "leave",
    CREATE: "leave",
    UPDATE: "leave/update",
    DELETE: "leave",
    LEAVE_APPROVAL: "leave-approval",
  },
  LESSON_PLAN: {
    GET: "lesson-plan",
    GET_LESSON_PLAN: "lesson-plan",
    CREATE: "lesson-plan",
    UPDATE: "lesson-plan",
    DELETE: "lesson-plan",
    FORM_OPTIONS: "lesson-plan/form-options",
    FILTER_OPTIONS: "lesson-plan/filter-options",
    // Appended to `lesson-plan/{id}/`
    COMPLETE: "complete",
    FLAG: "flag",
    REVIEW_TAG: "review-tag",
  },
  WEEKLY_DIARY: {
    OVERVIEW: "lesson-plan/diary/overview",
    GET: "lesson-plan/diary",
    SUBMIT: "lesson-plan/diary/submit",
    APPROVE: "lesson-plan/diary/approve",
  },
  MEETING_WITH_TYPES: {
    GET: "meeting-with-types",
    GET_MEETING_WITH_TYPE: "meeting-with-types",
    CREATE: "meeting-with-types",
    UPDATE: "meeting-with-types",
    DELETE: "meeting-with-types",
  },
  NEWS_LETTER: {
    GET: "newsletter",
    GET_NEWS_LETTER: "newsletter",
    CREATE: "newsletter",
    UPDATE: "newsletter/update",
    DELETE: "newsletter",
  },
  NOTIFICATION: {
    GET: "notification",
    GET_NOTIFICATION: "notification",
    CREATE: "notification",
    UPDATE: "notification",
    DELETE: "notification",
    BULK_UPLOAD: "bulk-upload-notification",
  },
  ORGANIZATION: {
    GET: "organizations",
    GET_ORGANIZATION: "organizations",
    CREATE: "organizations",
    UPDATE: "organizations",
    DELETE: "organizations",
    USER_ORGANIZATION: "user/organizations",
    GET_ORGANIZATION_LIST: "organization-list",
  },
  PARENT_APP_FEATURES: {
    LIST: "parent-app-features",
    UPDATE: "parent-app-features",
    CREATE: "parent-app-features",
  },
  PARENT_REQUEST: {
    GET: "parent-request",
    APPROVE_REJECT_REQUEST: "approve-reject/parent-request",
  },
  PROGRAM: {
    GET: "programs",
    GET_PROGRAM: "programs",
    CREATE: "programs",
    UPDATE: "programs",
    DELETE: "programs",
    GET_CLASS_IN_CHARGE_CLASSES: "class_in_charge/classes",
    GET_PROGRAM_LIST: "program-list",
    PROGRAM_SESSION_MAPPING: "programs-session-mapping",
    GET_PROGRAM_SESSION_MAPPING: "get-programs-session-mapping",
  },
  QUERY: {
    GET: "queries",
    GET_QUERY: "queries",
    CREATE: "queries",
    QUERY_REPLY: "queries/reply",
    UPDATE: "queries",
  },
  QUERY_CATEGORY: {
    CREATE: "query-category",
    DELETE: "query-category",
    GET: "query-category",
    GET_QUERY_CATEGORY: "query-category",
    UPDATE: "query-category",
  },
  REPORT_CARD: {
    VIEW: "reportcard",
    DOWNLOAD: "download-reportcard",
    EXCEL_RESULT: "export-result",
    PUBLISH_RESULT_LIST: "publish/result",
    PUBLISH_RESULT: "publish/result",
    UPDATE_PUBLISH_RESULT: "publish/result",
    GET_PUBLISHED_RESULT: "publish/result",
    CLASS_WISE_REPORT_CARD: "class-wise-report-card",
    REPORT_CARD_DOWNLOAD: "report-card-download",
  },
  RESULT: {
    CLASS_WISE: "teacher/analysis/class-wise",
    TEACHER_WISE: "/teacher/analysis",
    CBSE_RESULT: "cbse/upload-result",
    CLASS_RESULT_JSON: "class-result-json",
  },
  ROLE_PERMISSION: {
    GET: "roles",
    GET_ROLE_PERMISSION: "role/permissions",
    CREATE: "role/permission",
    UPDATE: "update/role/permissions",
    DELETE: "roles",
    GET_PERMISSION: "permissions",
    GET_PERMISSION_BY_USER: "permissions/by-user",
  },
  S3_SERVICE: {
    VIEW_FILE_FROM_S3: "view-file-from-s3",
  },
  SCORE_SCHEME: {
    GET: "score/schemes",
    GET_SCORE_SCHEME: "score/schemes",
    CREATE: "score/schemes",
    UPDATE: "score/schemes",
    DELETE: "score/schemes",
    GET_BY_EVALUATION_TYPE: "evaluation-wise/score-schemes",
  },
  SESSION: {
    GET: "sessions",
    GET_SESSION: "sessions",
    CREATE: "sessions",
    UPDATE: "sessions",
    DELETE: "sessions",
  },

  STACK_HOLDER_QUERY: {
    GET: "stakeholder-query/list",
    GET_QUERY: "queries",
    CREATE: "queries",
    QUERY_REPLY: "stakeholder-query/reply",
    UPDATE: "queries",
    STACK_HOLDER_QUERY_STATUS: "stakeholder-query/view-by",
    STACK_HOLDER_QUERY_DASHBOARD: "stakeholder-query/dashboard",
    SAVE_WEB_FCM_TOKEN: "save-web-fcm-token",
    GET_REQUEST_TYPE_LIST: "/stakeholder-query/request-type",
    GET_FLAG_LIST: "/stakeholder-query/flag",
    UPDATE_FLAG: "/stakeholder-query/set-flag",
    UPDATE_STATUS: "/stakeholder-query/set-status",
    UPDATE_REQUEST_SUB_TYPE: "/stakeholder-query/set-request-subtype",
    REMOVE_REPLY_ATTACHMENT: "/stakeholder-query/remove-reply-attachment",
    ADD_SUGGESTION: "/stakeholder-query/suggestions",
    GET_QUERY_VIEWER_USERS: "/stakeholder-query/viewer-users",
  },

  STAKEHOLDER_REQUEST_TYPE: {
    GET: "stakeholder-query/request-type-and-subtypes",
    GET_BY_ID: "stakeholder-query/request-type-and-subtypes",
    CREATE: "stakeholder-query/request-type-and-subtypes",
    UPDATE: "stakeholder-query/request-type-and-subtypes",
    DELETE: "stakeholder-query/request-type-and-subtypes",
  },

  STUDENT: {
    GET: "student/list",
    GET_STUDENT: "students",
    GET_FILTERED_STUDENTS: "filter/student/list",
    GET_CLASS_WISE_STUDENT_LIST: "class-wise/student/list",
    CREATE: "students",
    UPDATE: "student/update",
    DELETE: "students",
    STATUS: "student/status-update",
    BULK_CREATE: "/students/bulk-upload",
    BULK_UPDATE: "/students/update/bulk-upload",
    DIRECT_UPDATE: "/students/direct/update",
    PROMOTE_STUDENTS: "/promote/student",
    MANAGED_PROMOTED_STUDENTS: "/update/promoted/students",
    BULK_PROMOTE: "/students/bulk-permote",
    GENRATE_ACTIVATION_KEY: "/students/generate-activation-key",
    PARENT_APP_ACTIVATED_INACTIVATED_USER_COUNT:
      "/parent-app/activated-inactivated-user/count",
    STORE_FABS_DATA_ENROLLEMENT: "/store/fabs-student/enrollment",
    GET_STUDENT_DATA_FOR_SYNC: "/fatch/fabs-student/enrollment",
    SYNC_STUDENT_DATA: "/fabs-student/program/mapping/evs",
    DOWNLOAD_STUDENT_DATA: "/download/students",
  },
  STUDENT_APP_FEATURES: {
    LIST: "student/features",
  },
  STUDENT_SUBJECT_MAPPING: {
    GET: "student-subject-mapping",
    GET_STUDENT_SUBJECT_MAPPING: "student-subject-mapping",
    CREATE: "student-subject-mapping",
    UPDATE: "student-subject-mapping/update",
    DELETE: "student-subject-mapping",
    GET_STUDENT_ENROLLED_SUBJECTS: "student-enrolled-subjects",
    STUDENT_ENROLL_INTO_SUBJECTS: "student-enroll-into-subjects",
    GET_STUDENT_COUNT_SUBJECT_WISE: "student-count-subject-wise",
  },
  SUBJECT: {
    GET: "subjects",
    GET_SUBJECT: "subjects",
    CREATE: "subjects",
    UPDATE: "subjects",
    DELETE: "subjects",
    GET_CLASS_WISE_SUBJECTS: "programs-wise/subjects",
  },
  SURVEY: {
    GET: "surveys",
    CREATE: "surveys",
    GET_SURVEY: "surveys",
    UPDATE: "surveys",
    DELETE: "surveys",
    GET_SM_FOLDERS: "surveys/folders",
    GET_AVAILABLE: "surveys/available",
    GET_ASSIGNABLE_STUDENTS: "surveys/assignable-students",
    RESULTS: "results",
    COMPLETION: "completion",
    EXPORT_COMPLETION: "completion/export",
    ANALYTICS: "analytics",
    STUDENT_RESULT: "result",
    SM_RESPONSES: "sm-responses",
    REMIND: "remind",
  },
  SURVEY_FOLDER: {
    GET: "survey-folders",
    CREATE: "survey-folders",
    GET_FOLDER: "survey-folders",
    UPDATE: "survey-folders",
    DELETE: "survey-folders",
    FOLDER_SURVEYS: "surveys",
  },
  SYLLABUS: {
    GET: "syllabus",
    GET_SYLLABUS: "syllabus",
    CREATE: "syllabus",
    UPDATE: "syllabus/update",
    DELETE: "syllabus",
  },
  TEACHER: {
    GET: "teacher/list",
    GET_TEACHER: "teachers",
    GET_TEACHER_SUBJECT_MAPPING: "/users/subjects",
    CREATE_TEACHER_SUBJECT_MAPPING: "/users/subjects",
    UPDATE_TEACHER_SUBJECT_MAPPING: "/update/user/subjects",
    UPDATE_PASSWORD: "/users/reset-password",
    BULK_CREATE: "/teachers/bulk-upload",
    BULK_UPDATE: "/teachers/update/bulk-upload",
    SUBJECT_MAPPING_CREATE: "/teacher/subject-mapping",
    SUBJECT_MAPPING_UPDATE: "/teacher/subject-mapping/update",
    TEACHER_SUBJECT_MAPPING_BULK_UPLOAD: "/user/class/subject_bulk-upload",
    UPDATE_TEACHER_TIMETABLE_STATUS: "/update/teacher/timetable-status",
    TEACHER_TIMETABLE_NOTIFICATION_GET: "/teacher-timetable-notification",
    UPDATE_NOTIFICATION_STATUS: "/teacher/notification/is-read",
  },
  TEMPLATE: {
    GET: "templates",
    GET_TEMPLATE: "templates",
    CREATE: "templates",
    UPDATE: "templates",
    DELETE: "templates",
    BULK_PUBLISH_DATE: "templates/bulk-publish-date",
  },
  TIME_TABLE: {
    GET: "time-table",
    GET_TIME_TABLE: "time-table",
    CREATE: "time-table",
    UPDATE: "time-table",
    DELETE: "time-table",
  },
  TRAIT: {
    GET: "subject/traits",
    GET_TRAIT: "subject/traits",
    CREATE: "subject/traits",
    UPDATE: "subject/traits",
    DELETE: "subject/traits",
  },
  UPLOAD_TIME_TABLE: {
    GET: "upload-timetable",
    GET_UPLOAD_TIME_TABLE: "upload-timetable",
    CREATE: "upload-timetable",
    UPDATE: "upload-timetable/update",
    DELETE: "upload-timetable",
  },
  USER: {
    GET: "users",
    GET_USER: "users",
    CREATE: "users",
    UPDATE: "users",
    DELETE: "users",
    STATUS: "users/status",
    BULK_UPLOAD: "user/bulk-upload",
    UPDATE_PASSWORD: "users/update-password",
    UPLOAD_PROFILE_IMAGE: "user/upload-profile-image",
    UPLOAD_TEACHER_TIME_TABLE: "teacher-timetable-upload",
  },
  VISITOR: {
    GET: "visitor/list",
    GET_VISITOR: "visitor",
    CREATE: "visitor/create",
    UPDATE: "visitor/update",
    DELETE: "visitor/delete",
    CHECK_OUT: "visitor/checkout",
    GATE_PASS: "visitor/generate-pass",
    LOGS: "visitor/logs",
    PASS: "visitor/pass",
  },
  WORD_OF_THE_DAY: {
    GET: "word_of_the_day",
    GET_WORD_OF_THE_DAY: "word_of_the_day",
    CREATE: "word_of_the_day",
    UPDATE: "word_of_the_day",
    DELETE: "word_of_the_day",
    BULK_UPLOAD: "word_of_the_day/bulk-upload",
  },
};
